import {makeStyles} from '@material-ui/core/styles'
import {PaperCard} from '../../1elements'
import SelectResourceSet from './SelectResourceSet'
import SelectedFeatureSet from './SelectedFeatureSet'

const GroupCreationFormCard2 = ({
    selectedFeatureSets, setSelectedFeatureSets, territories, setTerritories, businesses, setBusinesses, showError
}) => {
    const classes = useStyles()

    return (
        <PaperCard className={classes.root}>
            <SelectedFeatureSet selectedFeatureSets={selectedFeatureSets}
                                setSelectedFeatureSets={setSelectedFeatureSets}
                                showError={showError}/>

            <SelectResourceSet  territories={territories}
                                setTerritories={setTerritories}
                                businesses={businesses}
                                setBusinesses={setBusinesses}
                                showError={showError}/>
        </PaperCard>
    )
}

export default GroupCreationFormCard2

const useStyles = makeStyles({
    root: {
        '&>div>*': {
            marginBottom: '30px'
        }
    }
})